// Illustrations célestes par signe — auto-hébergées en WebP optimisé, servies depuis notre domaine
const z = (key) => `/images/zodiac/${key}.webp`;

export const ZODIAC_IMAGES = {
  belier: z("belier"),
  taureau: z("taureau"),
  gemeaux: z("gemeaux"),
  cancer: z("cancer"),
  lion: z("lion"),
  vierge: z("vierge"),
  balance: z("balance"),
  scorpion: z("scorpion"),
  sagittaire: z("sagittaire"),
  capricorne: z("capricorne"),
  verseau: z("verseau"),
  poissons: z("poissons"),
};
